import './style.scss';
import { ReactNode } from 'react';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import { Button, ButtonFill, ButtonSize } from 'views/mutual/button';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import { PagePath } from 'constants/pagePath';
import Logo from 'assets/logo_blue.svg';

export type ErrorPageProps = {
  message?: ReactNode;
  linkText?: string;
  linkPath?: string;
};

const createErrorMessage = (error: any) => {
  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return 'お探しのページが見つかりませんでした。';
    }
  }

  return '申し訳ありません。エラーが発生しました。';
};

export const ErrorPage = (props: ErrorPageProps) => {
  const navigate = useNavigate();
  const error = useRouteError();

  let errorMessage = props.message ?? createErrorMessage(error);

  return (
    <>
      <div className="errorPage">
        <div className="errorPage_header">
          <img src={Logo} alt="Logo" />
        </div>
        <Description label={errorMessage} labelColor={labelColor.black} labelSize={labelSize.medium} />
        <Button
          label={props.linkText ?? 'TOPに戻る'}
          buttonFill={ButtonFill.link}
          buttonSize={ButtonSize.small}
          onClick={() => navigate(props.linkPath ?? PagePath.Root)}
        />
      </div>
    </>
  );
};
